import styled, { css } from "styled-components";
import MinusIcon from "core/icons/minus/minus.svg";
import Transitions from "core/constants/transitions";
import {
  GetMarginStyle,
  GetPaddingStyle,
  getMarginStyle,
  getPaddingStyle,
} from "core/styles/paddingMarginStyle";
import { DefaultTheme } from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto;
  overflow-anchor: none;
`;

export const angleVariant = ({ theme }: DefaultTheme) =>
  theme.variant === "angle" &&
  css`
    background-color: ${theme?.colors?.white};
    align-items: center;
    padding: 16px;
    padding-right: 60px;
    border-radius: 8px;
    border: 1px solid ${theme?.colors?.neutral.neutral40};

    :before,
    :after {
      display: none;
    }
  `;

export const crossVariant = ({ theme }: DefaultTheme) =>
  theme.variant === "cross" &&
  css`
    &:before,
    &:after {
      content: "";
      position: absolute;
      flex-shrink: 0;
      box-sizing: border-box;
      top: 50%;
      width: 16px;
      height: 3px;
      background: url(${MinusIcon});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center center;

      ${({ plusIconColor }) => {
        if (plusIconColor) {
          return css`
            background-blend-mode: overlay;
            background-color: ${plusIconColor};
          `;
        }
      }}
    }

    &:before {
      right: 8px;
      transition: transform 0.35s ${Transitions.cubicBezier};
      transform: ${({
        // @ts-expect-error TS(2339): Property 'active' does not exist on type 'ThemePro... Remove this comment to see the full error message
        active,
      }) => !active && "rotate(90deg)"};
    }

    &:after {
      right: 8px;
    }
  `;

export const HeaderContainer = styled.div<{ plusIconColor: string }>`
  display: flex;
  position: relative;
  align-items: center;
  padding: 16px 0px;
  padding-right: ${({ theme }) => (theme.variant === "cross" ? "32px" : "72px")};
  min-height: 32px;
  cursor: ${({ onClick }) => onClick && "pointer"};

  ${crossVariant}
  ${angleVariant}
`;

// const activeStyle = ({ active }) =>
//   active &&
//   css`
//     display: flex;
//     overflow: hidden;
//   `;

// const collapsingStyle = ({ isCollapsing, collapsingDuration }) =>
//   isCollapsing &&
//   css`
//     height: 0;
//     transition: height ${collapsingDuration}s ease;
//   `;

export const BodyContainer = styled.div<
  { active?: boolean; direction?: "row" | "column" } & GetMarginStyle & GetPaddingStyle
>`
  display: ${({ active }) => (active ? "flex" : "none")};
  flex-direction: ${({ direction }) => direction || "column"};
  margin-bottom: ${({ active }) => (active ? "16px" : "0px")};

  ${getMarginStyle}
  ${getPaddingStyle}
`;

export const ItemContainer = styled.div`
  border-bottom: ${({ theme }) =>
    theme.variant === "cross" && `1.5px solid ${theme?.colors?.gray.gray10}`};
  margin-bottom: ${({ theme }) => theme.variant === "angle" && "24px"};
`;

const angleActiveStyle = ({ theme }: any) =>
  theme.active &&
  css`
    transform: rotate(180deg);
    background-color: ${theme?.colors?.primary.surface};

    path {
      stroke: ${theme?.colors?.primary.default};
    }
  `;

export const AngleWrapper = styled.div`
  position: absolute;
  right: 16px;
  display: ${({ theme }) =>
    theme.variant === "angle" || theme.variant === "angle-v2" ? "flex" : "none"};
  flex-shrink: 0;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  transition: 0.3s all ${Transitions.cubicBezier};

  ${angleActiveStyle}
`;
